<div class="vertical-menu">
  <div class="navbar-brand-box p-0 px-2">
    <a routerLink="/" class="logo logo-dark">
      <span class="logo-sm">
        <img [src]="mainLogoSmall" alt="" class="w-100" />
      </span>
      <span class="logo-lg">
        <span class="env-dev-logo w-50" [class.is-dev]="isDevEnv">
          <img [src]="mainLogo" alt="" class="w-100" />
        </span>
      </span>
    </a>

    <a routerLink="/" class="logo logo-light">
      <span class="logo-sm">
        <img [src]="mainLogoSmall" alt="" class="w-100" />
      </span>
      <span class="logo-lg">
        <span class="env-dev-logo w-50" [class.is-dev]="isDevEnv">
          <img [src]="mainLogoDark" alt="" class="w-100" />
        </span>
      </span>
    </a>
  </div>

  <button
    type="button"
    class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
    (click)="toggleMobileMenu($event)"
  >
    <i class="fa fa-fw fa-bars"></i>
  </button>
  <ngx-simplebar class="sidebar-menu-scroll" style="max-height: 100vh">
    <div id="sidebar-menu" class="position-relative">
      <ul class="metismenu list-unstyled" id="side-menu">
        <ng-container>
          <!-- <li *ngIf="item.link !== ''">
            <a
              *ngIf="hasItems(item)"
              href="javascript:void(0);"
              class="is-parent"
              [ngClass]="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
            >
              <i-feather name="{{ item.icon }}" class="me-1 nav-icon"></i-feather>
              <span class="menu-item"> {{ item.moduleKey ?? '' | translate }}</span>
            </a>
            <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref" routerLinkActive="active">
              <i-feather name="{{ item.icon }}" *ngIf="item.icon" class="me-1 nav-icon"></i-feather>
              <span class="menu-item"> {{ item.moduleKey ?? '' | translate }}</span>
            </a>
            <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
              <li *ngFor="let subitem of item.submodules">
                <a
                  [routerLink]="subitem.link"
                  *ngIf="!hasItems(subitem)"
                  class="side-nav-link-ref"
                  [attr.data-parent]="item._id"
                  routerLinkActive="active"
                >
                  <i-feather name="{{ subitem.icon }}" *ngIf="subitem.icon" class="me-1 nav-icon nav-list"></i-feather>
                  {{ subitem.moduleKey | translate }}
                </a>
                <a
                  *ngIf="hasItems(subitem)"
                  class="side-nav-link-a-ref has-arrow"
                  href="javascript:void(0);"
                  [attr.data-parent]="item._id"
                >
                  {{ subitem.moduleKey | translate }}
                </a>
              </li>
            </ul>
          </li> -->
          <li>
            <a
              [routerLink]="['']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['dashboard_read', 'dashboard_read_write']"
            >
              <i-feather class="icon-lg" name="grid"></i-feather>
              <span class="menu-item">{{ 'dashboard.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['application-users']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['applicationUsers_read', 'applicationUsers_read_write']"
            >
              <i-feather class="icon-lg" name="users"></i-feather>
              <span class="menu-item">{{ 'applicationUsers.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['business']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['business_read', 'business_read_write']"
            >
              <i-feather class="icon-lg" name="briefcase"></i-feather>
              <span class="menu-item">{{ 'business.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['business-sales']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['businessSales_read', 'businessSales_read_write']"
            >
              <i-feather class="icon-lg" name="tag"></i-feather>
              <span class="menu-item">{{ 'businessSales.value' | translate }} </span>
              <span *ngIf="pendingCounts.pendingBusinessSales" class="badge bg-danger">{{
                pendingCounts.pendingBusinessSales
              }}</span>
            </a>
          </li>
          <!-- <li>
            <a
              [routerLink]="['app-home-page']"
              class="side-nav-link-ref d-flex"
              routerLinkActive="active"
              *ngxPermissionsOnly="['appHomePage_read', 'appHomePage_read_write']"
            >
              <i-feather class="icon-lg" name="command"></i-feather>
              <span class="menu-item">{{ 'appHomePageTitle.value' | translate }}</span>
            </a>
          </li> -->
          <li>
            <a
              [routerLink]="['nirlat-team']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['nirlatTeams_read', 'nirlatTeams_read_write']"
            >
              <i-feather class="icon-lg" name="framer"></i-feather>
              <span class="menu-item">{{ 'nirlatTeams.value' | translate }}</span>
              <span *ngIf="pendingCounts.pendingPosts" class="badge bg-danger">{{ pendingCounts.pendingPosts }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['jobs']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['jobs_read', 'jobs_read_write']"
            >
              <i-feather class="icon-lg" name="briefcase"></i-feather>
              <span class="menu-item">{{ 'connectionsToWork.value' | translate }}</span>
              <span *ngIf="pendingCounts.pendingJobs" class="badge bg-danger">{{ pendingCounts.pendingJobs }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['scanned-invoices']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['scannedInvoices_read', 'scannedInvoices_read_write']"
            >
              <i-feather class="icon-lg" name="maximize"></i-feather>
              <span class="menu-item">{{ 'scannedInvoice.value' | translate }}</span>
              <span *ngIf="pendingCounts.pendingInvoices" class="badge bg-danger">{{
                pendingCounts.pendingInvoices
              }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['push-notification']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['pushNotification_read', 'pushNotification_read_write']"
            >
              <i-feather class="icon-lg" name="bell"></i-feather>
              <span class="menu-item">{{ 'pushNotificationTitle.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['/business-card']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['businessCard_read', 'businessCard_read_write']"
            >
              <i-feather class="icon-lg" name="credit-card"></i-feather>
              <span class="menu-item">{{ 'businessCard.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['color-fan']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['colorFans_read', 'colorFans_read_write']"
            >
              <i-feather class="icon-lg" name="codesandbox"></i-feather>
              <span class="menu-item">{{ 'colorFan.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['color-combination']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['colorCombination_read', 'colorCombination_read_write']"
            >
              <i-feather class="icon-lg" name="aperture"></i-feather>
              <span class="menu-item">{{ 'colorCombination.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['buy-me-orders']"
              class="side-nav-link-ref ps-2"
              routerLinkActive="active"
              *ngxPermissionsOnly="['buyMeOrders_read', 'buyMeOrders_read_write']"
            >
              <img
                class="header-profile-user p-0 border-0 img-fluid"
                [src]="'assets/images/logo/buyMeGiftLogo.png'"
                alt="Buy me gifts"
              />
              <span class="menu-item ms-2">{{ 'buyMeOrders.value' | translate }}</span>
            </a>
          </li>
          <!-- <li>
            <a
              [routerLink]="['nirlat-gifts-orders']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['nirlatGiftOrders_read', 'nirlatGiftOrders_read_write']"
            >
              <i-feather class="icon-lg" name="shopping-bag"></i-feather>
              <span class="menu-item">{{ 'nirlatGiftOrders.value' | translate }}</span>
              <span *ngIf="pendingCounts.pendingNirlatGiftOrders" class="badge bg-danger">{{
                pendingCounts.pendingNirlatGiftOrders
              }}</span>
            </a>
          </li> -->
          <!-- <li>
            <a
              [routerLink]="['nirlat-gifts']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['nirlatGifts_read', 'nirlatGifts_read_write']"
            >
              <i-feather class="icon-lg" name="gift"></i-feather>
              <span class="menu-item">{{ 'nirlatGifts.value' | translate }}</span>
            </a>
          </li> -->
          <li>
            <a
              [routerLink]="['supplier']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['suppliers_read', 'suppliers_read_write']"
            >
              <i-feather class="icon-lg" name="shopping-bag"></i-feather>
              <span class="menu-item">{{ 'supplierGift.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['nirlat-consultation']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['nirlatConsultation_read', 'nirlatConsultation_read_write']"
            >
              <i-feather class="icon-lg" name="info"></i-feather>
              <span class="menu-item">{{ 'nirlatConsultation.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['event-registration']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['eventRegistration_read', 'eventRegistration_read_write']"
            >
              <i-feather class="icon-lg" name="calendar"></i-feather>
              <span class="menu-item">{{ 'eventRegistrationNav.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['product']"
              class="side-nav-link-ref d-flex"
              routerLinkActive="active"
              *ngxPermissionsOnly="['productList_read', 'productList_read_write']"
            >
              <i-feather class="icon-lg" name="shopping-cart"></i-feather>
              <span class="menu-item">{{ 'productList.value' | translate }}</span>
            </a>
          </li>

          <li>
            <a
              [routerLink]="['/point-managment']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['pointManagement_read', 'pointManagement_read_write']"
            >
              <i-feather class="icon-lg" name="star"></i-feather>
              <span class="menu-item">{{ 'pointManagement.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['nirlat-promotion']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['nirlatPromotions_read', 'nirlatPromotions_read_write']"
            >
              <i-feather class="icon-lg" name="table"></i-feather>
              <span class="menu-item">{{ 'nirlatPromotions.value' | translate }}</span>
            </a>
          </li>
          <!-- <li>
            <a
              [routerLink]="['/onboarding-screens']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['onBoardingScreens_read', 'onBoardingScreens_read_write']"
            >
              <i-feather class="icon" name="monitor"></i-feather>
              <span class="menu-item">{{ 'onboardingScreens.value' | translate }}</span>
            </a>
          </li> -->
          <li>
            <a
              [routerLink]="['/app-content/list']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['appContents_read', 'appContents_read_write']"
            >
              <i-feather class="icon-lg" name="book-open"></i-feather>
              <span class="menu-item">{{ 'appContent.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['app-dictionary']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['appDictionary_read', 'appDictionary_read_write']"
            >
              <i-feather class="icon-lg" name="book"></i-feather>
              <span class="menu-item">{{ 'appDictionary.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['system-admin']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['systemAdmins_read', 'systemAdmins_read_write']"
            >
              <i-feather class="icon-lg" name="user-plus"></i-feather>
              <span class="menu-item">{{ 'systemAdmin.value' | translate }}</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['general-settings']"
              class="side-nav-link-ref"
              routerLinkActive="active"
              *ngxPermissionsOnly="['generalSettings_read', 'generalSettings_read_write']"
            >
              <i-feather class="icon-lg" name="settings"></i-feather>
              <span class="menu-item">{{ 'generalSettings.value' | translate }}</span>
            </a>
          </li>
          <!-- Release notes. No *ngxPermissionsOnly on purpose: it carries no data, and every admin
               type should see what shipped without a permissions row being created for them first. -->
          <li>
            <a [routerLink]="['whats-new']" class="side-nav-link-ref" routerLinkActive="active">
              <i-feather class="icon-lg" name="zap"></i-feather>
              <span class="menu-item">{{ 'whatsNew.value' | translate }}</span>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </ngx-simplebar>
  <!-- <div
      class="d-block border-top border-bottom border-black-50 position-absolute bottom-0 w-100 px-2 py-3"
      id="sidemenu-profile"
    >
      <div class="user text-start d-flex align-items-center w-100" *ngIf="_currentUser">
        <img
          class="rounded-circle header-profile-user"
          [src]="_currentUser.profileImage ? baseUrl + _currentUser.profileImage : 'assets/images/users/avatar-1.jpg'"
          alt="Header Avatar"
        />
        <span class="ms-2 d-block hide d-flex flex-column gap-1">
          <span class="fs-6 fw-bold">{{ _currentUser.firstName }} {{ _currentUser.lastName }}</span>
          <span class="text-black-50"> {{ _currentUser.adminTypedata?.adminTypeName | titlecase }} </span>
        </span>
        <span class="btn px-0 ms-auto cursor-pointer" (click)="logout()">
          <i class="mdi mdi-logout fs-4 align-middle"></i>
        </span>
      </div>
    </div> -->
</div>
